import { render, staticRenderFns } from "./LandingTemplatePRP.vue?vue&type=template&id=44c9f283&scoped=true&"
import script from "./LandingTemplatePRP.vue?vue&type=script&lang=js&"
export * from "./LandingTemplatePRP.vue?vue&type=script&lang=js&"
import style0 from "./LandingTemplatePRP.vue?vue&type=style&index=0&id=44c9f283&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c9f283",
  null
  
)

export default component.exports